import { render, staticRenderFns } from "./FreeSelectPhonetic.vue?vue&type=template&id=fdd65aa6&scoped=true"
import script from "./FreeSelectPhonetic.vue?vue&type=script&lang=js"
export * from "./FreeSelectPhonetic.vue?vue&type=script&lang=js"
import style0 from "./FreeSelectPhonetic.vue?vue&type=style&index=0&id=fdd65aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd65aa6",
  null
  
)

export default component.exports